import { ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';

interface IProps {
  onSearch: () => void;
  onRefresh: () => void;
}

export function BaseFormSearchActions(props: IProps) {
  return (
    <Space>
      <Tooltip title="Tìm kiếm">
        <Button type="primary" size="large" onClick={props.onSearch} icon={<SearchOutlined />} />
      </Tooltip>
      <Tooltip title="Làm mới">
        <Button type="dashed" size="large" onClick={props.onRefresh} icon={<ReloadOutlined />} />
      </Tooltip>
    </Space>
  );
}
